import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/public/assets/css/category/category-info.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/Action.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/ActionMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/Description.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/Filter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/ProductCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/ProductCardList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/ProductCardMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/SelectedFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(san-pham)/san-pham/[slug]/_components/SupplierCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/ExtraView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/icon.tsx");
